<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="agent-information content-wrapper">
      <div class="page-header">{{ $t('editInformation') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'AgentInfo' }">{{ $t('agentInformation') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editInformation') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-container>
        <el-main>
          <el-form ref="form"  label-width="150px">
            <el-form-item label="">
              <el-radio v-model="agent.isEnable" :label="STATUS.ENABLE">{{$t('STATUS.ENABLE')}}</el-radio>
              <el-radio v-model="agent.isEnable" :label="STATUS.DISABLE">{{$t('STATUS.DISABLE')}}</el-radio>
            </el-form-item>
            <el-form-item :label="$t('name')" :required="true">
              <el-col :span="24">
                <el-input type="text" v-model="agent.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('type')">
              <el-col :span="24">
                <el-select v-model="agent.agentTypeId" placeholder="-">
                  <el-option
                    v-for="(agentType, index) in agentTypeList"
                    :key="index"
                    :label="agentType.name"
                    :value="agentType.id">
                  </el-option>
                  <el-option :label="$t('otherAgentType')" value="0"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('agentTypeName')" :required="true" v-if="agent.agentTypeId === '0'">
              <el-col :span="24">
                <el-input type="text" v-model="agent.agentTypeName"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('market')" size="mini">
              <el-col :span="24">
                <el-button type="info"
                           icon="el-icon-plus"
                           @click="onAddMarketButtonClick">
                  {{ $t('newMarket') }}
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item label="" v-if="marketIdList.length > 0" size="mini">
              <el-col :span="24">
                <el-button plain
                           v-for="marketId in marketIdList"
                           icon="el-icon-minus remove-market-icon"
                           :key="marketId"
                           :class="{ disable: isDisabledMarket(marketId) }"
                           @click="onRemoveMarketButtonClick(marketId)">
                  <span v-if="isDisabledMarket(marketId)">[{{ $t('STATUS.DISABLE') }}]</span>
                  {{ bindMarketName(marketId) }}
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('address')">
              <el-col :span="24">
                <el-input type="textarea" :rows="3" v-model="agent.information.address"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('country')">
              <el-col :span="12">
                <el-input v-model="agent.information.country"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('zipCode')">
              <el-col :span="12">
                <el-input v-model="agent.information.zipCode"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item  :key="`email-${index}`" v-for="(email, index) in agent.information.emailList" :label="bindLabel(index, $t('email'))">
              <el-col :span="12">
                <el-input v-model="agent.information.emailList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2" >
                <el-button type="danger" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('emailList', index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4"><el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('emailList')">{{$t('addEmail')}}</el-button></el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item :key="`phone-${index}`" v-for="(phone, index) in agent.information.phoneList" :label="bindLabel(index, $t('tel'))">
              <el-col :span="12">
                <el-input v-model="agent.information.phoneList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2" >
                <el-button type="danger" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('phoneList', index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4">
                <el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('phoneList')">{{$t('addTel')}}</el-button>
              </el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item  :key="`fax-${index}`" v-for="(fax, index) in agent.information.faxList" :label="bindLabel(index, $t('fax'))">
              <el-col :span="12">
                <el-input v-model="agent.information.faxList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2" >
                <el-button type="danger" icon="el-icon-delete" circle @click="onRemoveItemButtonClick('faxList', index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item label="">
              <el-col :span="4">
                <el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('faxList')">{{$t('addFax')}}</el-button>
              </el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item :label="$t('internalNote')">
              <el-input type="textarea" v-model="agent.internalNote"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="onSaveAgentInfoButtonClick">{{$t('saveChange')}}</el-button>
                <el-button type="default" @click="onCancelButtonClick">{{$t('cancel')}}</el-button>
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
    </div>
    <popup-market-list
      :visible="isShowDialog"
      :selected-market-id-list="marketIdList"
      :market-list="filteredMarketList"
      @onClose="onClosePopup()"
      @onAddMarket="onPopupAddMarketList">
    </popup-market-list>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Agent/ManageAgent/Information/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import AgentApi from '@/api/agent-api'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import PopupMarketList from '@/views/Agent/components/PopupMarketList'
import { get, map, trim } from 'lodash'

export default {
  name: 'EditAgentInfo',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { PopupMarketList, ContentContainer },
  i18n: { messages: i18nMessages },
  props: {
    agent: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedMarketIdList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      STATUS,
      isLoading: true,
      isShowDialog: false,
      marketIdList: [],
      filteredMarketList: []
    }
  },
  created () {
    this.isLoading = true
    if (this.agent == null || this.agent.id === undefined) {
      this.$router.push({
        name: 'AgentList'
      })
    }

    this.marketIdList = [ ...this.selectedMarketIdList ]

    this.prepareData()
    this.isLoading = false
  },
  methods: {
    prepareData: function () {
      if (this.agent.information.emailList.length === 0) {
        this.agent.information.emailList.push('')
      }

      if (this.agent.information.phoneList.length === 0) {
        this.agent.information.phoneList.push('')
      }

      if (this.agent.information.faxList.length === 0) {
        this.agent.information.faxList.push('')
      }
    },
    onAddMarketButtonClick: function () {
      this.filteredMarketList = _filterMarketList(this.marketList, this.marketIdList)
      this.isShowDialog = true
    },
    onAddMoreItemButtonClick: function (keyItem) {
      this.agent.information[keyItem].push('')
    },
    onRemoveItemButtonClick: function (keyItem, index) {
      this.agent.information[keyItem].splice(index, 1)
    },
    onPopupAddMarketList: function (marketId) {
      if (marketId !== '') {
        this.marketIdList.push(marketId)
      }
    },
    onClosePopup: function () {
      this.isShowDialog = false
    },
    bindLabel: function (index, defaultLabel) {
      return (index === 0) ? defaultLabel : ''
    },
    bindMarketName: function (marketId) {
      const market = this.marketList.find(market => market.id === marketId)

      return (market === undefined) ? '-' : market.name
    },
    isDisabledMarket: function (marketId) {
      const market = this.marketList.find(market => market.id === marketId)

      return (market === undefined || market.isEnable === STATUS.DISABLE)
    },
    onRemoveMarketButtonClick: async function (marketId) {
      const confirmMessage = this.$t('confirmRemoveMarketMessage')
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      this.removeMarket(marketId)
    },
    removeMarket: function (marketId) {
      this.marketIdList = this.marketIdList.filter(selectedMarketId => selectedMarketId !== marketId)
    },
    onSaveAgentInfoButtonClick: async function () {
      try {
        this.startLoading()

        this.agent.information.emailList = map(this.agent.information.emailList, trim)
        this.agent.information.phoneList = map(this.agent.information.phoneList, trim)
        this.agent.information.faxList = map(this.agent.information.faxList, trim)

        const agentTypeId = get(this.agent, 'agentTypeId', null)
        if (agentTypeId === null) {
          this.agent.agentTypeId = agentTypeId
        }

        const updateData = {
          agent: this.agent,
          selectedMarketList: this.marketIdList
        }

        const newAgentData = await AgentApi.update(this.agent.id, updateData)
        this._setUpdatedAgentDataToList(newAgentData)

        const title = this.$t('saveAgentInfoSuccessTitle')
        const message = this.$t('saveAgentInfoSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
      this.$router.push({
        name: 'AgentInfo'
      })
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'AgentInfo'
      })
    },
    _setUpdatedAgentDataToList: function (newAgentData) {
      const agentList = LocalStorageFactory.getAgentList()
      const newAgentList = agentList.map((agent) => {
        if (agent.id === newAgentData.id) {
          return newAgentData
        }

        return agent
      })

      LocalStorageFactory.setAgentList(newAgentList)
    }
  }
}

function _filterMarketList (marketList, selectedMarketIdList) {
  const filteredMarketList = marketList.filter((market) => (selectedMarketIdList.indexOf(market.id) < 0))
  const sortedMarketList = filteredMarketList.sort((a, b) => {
    return (a.name > b.name) ? 1 : -1
  })

  return sortedMarketList
}
</script>

<style>
  .remove-market-icon {
    padding: 2px;
    border-radius: 10px;
    background: #f00;
    color: #fff;
  }
  .el-button.disable {
    color: #d2d1d1;
  }
</style>
